import React from 'react';
import { Formik } from 'formik';
import { Form as SForm } from 'semantic-ui-react';
import * as Lookups from '../../../Hooks/LookupOptions';
import { PhysicalInfoSearchDto } from '@app/api2/api';
import { SEARCH_TYPES_NAMES } from '../../types';
import { PhysicalSearchSchema } from './PhysicalForm.Schema';
import SemanticFormikSelect from '@app/components/React/Common/Forms/SemanticFormikSelect';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import { FormWithButtons } from './FormWithButtons';

interface Props {
    currentParams: PhysicalInfoSearchDto;
    setCurrentParams: (p: PhysicalInfoSearchDto) => void;
}

export default function PhysicalForm({ currentParams, setCurrentParams }: Props) {
    const eyeColorOptions = Lookups.useEyeColorOptions({ defaultValue: currentParams.eyeColor });
    const hairColorOptions = Lookups.useHairColorOptions({ defaultValue: currentParams.hairColor });
    const discriminator = SEARCH_TYPES_NAMES.PhysicalInfoSearchDto;

    const initialValues: PhysicalInfoSearchDto = {
        discriminator,
        operator: currentParams.operator,
        eyeColor: currentParams.eyeColor,
        hairColor: currentParams.hairColor,
        height: currentParams.height,
        weight: currentParams.weight,
    };

    const handleSubmit = (values: PhysicalInfoSearchDto) => {
        setCurrentParams({ ...values, discriminator });
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={PhysicalSearchSchema}
            onSubmit={handleSubmit}
            validateOnBlur={false}
            validateOnChange={false}
            enableReinitialize
        >
            {({ handleSubmit }) => (
                <FormWithButtons handleSubmit={handleSubmit}>
                    <SForm.Group widths="equal">
                        <SemanticFormikSelect
                            name="eyeColor"
                            label="Eye Color"
                            placeholder="Select eye color"
                            options={eyeColorOptions.items}
                        />
                        <SemanticFormikSelect
                            name="hairColor"
                            label="Hair Color"
                            placeholder="Select hair color"
                            options={hairColorOptions.items}
                        />
                    </SForm.Group>
                    <SForm.Group widths="equal">
                        <SemanticFormikInput
                            name="height"
                            label="Height"
                            placeholder="e.g., 5'10"
                            type="number"
                        />
                        <SemanticFormikInput
                            name="weight"
                            label="Weight"
                            placeholder="e.g., 175"
                            type="number"
                        />
                    </SForm.Group>
                </FormWithButtons>
            )}
        </Formik>
    );
}
